import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getQuestionListAction,
  getQuestionTypeAction,
  gameListAction,
  gameNewlistAction,
  createGameNewsAction,
  uploadGamePictureAction,
  deleteGameListAction,
  changeGameManegentNewsAction,
  createGameAction,
  deleteGameAction,
  changeGameAction,
  uploadGamesPictureAction,
  outOrInGameAction
} from "../action/helpCenterAction";

export const helpCenterReducer = (
  builder: ActionReducerMapBuilder<{
    questionList: string;
    questionType: any;
    gameListConfig: any;
    gameNewListConfig: any;
    createGameNewsConfig: any;
    uploadGamePictureConfig: any;
    deleteGameListConfig: any;
    changeGameManegentNewsConfig: any,
    createGameConfig: any,
    deleteGameConfig: any,
    changeGameConfig: any,
    uploadGamesPictureConfig: any,
    outOrInGameConfig: any
  }>
) => {
  builder.addCase(getQuestionListAction.fulfilled, (state, { payload }) => {
    state.questionList = payload;
  });
  builder.addCase(getQuestionTypeAction.fulfilled, (state, { payload }) => {
    state.questionType = payload;
  });
  builder.addCase(gameListAction.fulfilled, (state, { payload }) => {
    state.gameListConfig = payload
  })
  builder.addCase(gameNewlistAction.fulfilled, (state, { payload }) => {
    state.gameNewListConfig = payload
  })
  builder.addCase(createGameNewsAction.fulfilled, (state, { payload }) => {
    state.createGameNewsConfig = payload
  })
  builder.addCase(uploadGamePictureAction.fulfilled, (state, { payload }) => {
    state.uploadGamePictureConfig = payload
  })
  builder.addCase(deleteGameListAction.fulfilled, (state, { payload }) => {
    state.deleteGameListConfig = payload
  })
  builder.addCase(changeGameManegentNewsAction.fulfilled, (state, { payload }) => {
    state.changeGameManegentNewsConfig = payload
  })
  builder.addCase(createGameAction.fulfilled, (state, { payload }) => {
    state.createGameConfig = payload
  })
  builder.addCase(deleteGameAction.fulfilled, (state, { payload }) => {
    state.deleteGameConfig = payload
  })
  builder.addCase(changeGameAction.fulfilled, (state, { payload }) => {
    state.changeGameConfig = payload
  })

  builder.addCase(uploadGamesPictureAction.fulfilled, (state, { payload }) => {
    state.uploadGamesPictureConfig = payload
  })
  builder.addCase(outOrInGameAction.fulfilled, (state, { payload }) => {
    state.outOrInGameConfig = payload
  })
};

